// extracted by mini-css-extract-plugin
export default {"menu":"MobileAccountSheet_menu__ttQKq","pills":"MobileAccountSheet_pills__-eGmf"};